import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-container show"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"400px"}
}
const _hoisted_4 = { class: "modal__content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "modal__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.dialog)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", {
              innerHTML: _ctx.message,
              class: "alert--message"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn--small",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, _toDisplayString(_ctx.noButtonText), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn--primary btn--small",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.agree && _ctx.agree(...args)))
            }, _toDisplayString(_ctx.yesButtonText), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}